import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteResource,
  getResourceState,
} from "../../redux/slices/resourceSlice.js";
import { getUIProperty, setUIProperty } from "../../redux/slices/uiSlice.js";
import { Button } from "devextreme-react/button";

import TradeCaseModal from "./TradeCaseModal.jsx";
import { isEmpty } from "lodash";
import notify from "devextreme/ui/notify";
import WarningModal from "../generic/WarningModal.jsx";
import { useHistory } from "react-router";
import { Typography } from "@material-ui/core";

const TradeCaseControls = ({ disabled }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const selectedTradeCaseId = useSelector((state) =>
    getUIProperty(state, "selectedTradeCaseId")
  );

  const [tradeCaseData, setTradeCaseData] = useState();
  const [showWarning, setShowWarning] = useState();
  const [ready, setReady] = useState(true);

  const [openCreateModal, setOpenCreateModal] = useState("");
  const [openEditModal, setOpenEditModal] = useState("");

  const tradeCases = useSelector((state) =>
    getResourceState(state, "trade_cases")
  );

  useEffect(() => {
    if (isEmpty(tradeCases)) return;
    setTradeCaseData(
      tradeCases.find((tradeCase) => tradeCase.id === selectedTradeCaseId)
    );
  }, [tradeCases, selectedTradeCaseId]);

  const handleDelete = () => {
    setReady(false);
    return dispatch(
      deleteResource({ path: "trade-case", id: selectedTradeCaseId })
    ).then(() => {
      setShowWarning(false);
      setReady(true);
      dispatch(setUIProperty({ name: "selectedTradeCaseId", value: null }));
      notify(
        `Deleted trade case with id ${selectedTradeCaseId}`,
        "success",
        2000
      );
    });
  };

  return (
    <div style={{ display: "flex", width: "100%" }}>
      <Button
        disabled={disabled}
        icon="back"
        style={{ marginRight: "8px" }}
        hint="Back to search"
        onClick={() => history.push("/admin/search")}
      />
      <Button
        disabled={disabled}
        icon="add"
        type="success"
        style={{ marginRight: "8px" }}
        hint="Add TradeCase"
        onClick={() => setOpenCreateModal("add")}
      />
      <Button
        icon="edit"
        disabled={!selectedTradeCaseId || disabled}
        type="normal"
        style={{ marginRight: "8px" }}
        hint="Edit TradeCase"
        onClick={() => setOpenEditModal("edit")}
      />
      <Button
        icon="trash"
        disabled={!selectedTradeCaseId || disabled}
        type="danger"
        hint="Delete TradeCase"
        onClick={() => setShowWarning(true)}
      />
      <Typography
        variant="h5"
        align="center"
        style={{ marginLeft: "auto", marginRight: "50%" }}
      >
        Trade Cases
      </Typography>
      {showWarning && (
        <WarningModal
          ready={ready}
          id={selectedTradeCaseId}
          text="Are you sure you want to delete trade case"
          visible={showWarning}
          handleYes={handleDelete}
          handleNo={() => setShowWarning(false)}
        />
      )}
      {!disabled && (
        <>
          <TradeCaseModal
            numOfCases={tradeCases.length}
            selectedTradeCaseId={selectedTradeCaseId}
            type="add"
            reduxName="tradeCase:new"
            tradeCaseData={tradeCaseData}
            visible={openCreateModal}
            setVisible={setOpenCreateModal}
          />
          <TradeCaseModal
            numOfCases={tradeCases.length}
            selectedTradeCaseId={selectedTradeCaseId}
            type="edit"
            reduxName={`tradeCase:${selectedTradeCaseId}`}
            tradeCaseData={tradeCaseData}
            visible={openEditModal}
            setVisible={setOpenEditModal}
          />
        </>
      )}
    </div>
  );
};
export default TradeCaseControls;
